var exports = {
  "f": "BlockedSectionMessage__s7x5gm",
  "G": "CircleOcticon__u3xwvJ",
};

module.exports = exports;
